
interface ProfileAvatarProps {
    photoUrl?: string | null;
    firstName?: string;
    size?: string;
    className?: string;
}

const ProfileAvatar = ({
    photoUrl,
    firstName,
    size = "w-10 h-10",
    className = "",
}: ProfileAvatarProps) => {
    return (
        <div
            className={`${size} ${className} flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-blue-100 text-blue-700 font-semibold`}
        >
            {photoUrl ? (
                <img
                    src={photoUrl}
                    alt="Profile"
                    className="w-full h-full rounded-full object-cover"
                />
            ) : (
                <p>
                    {firstName?.charAt(0)?.toUpperCase() || "U"}
                </p>
            )}
        </div>
    );
};

export default ProfileAvatar;
